const DEFAULT_OUTLOOK_COMPOSE =
  process.env.REACT_APP_OUTLOOK_COMPOSE_BASE ?? 'https://outlook.office.com/mail/deeplink/compose';

export const ISSUE_MAIL_BODY =
  'Hi,\r\nPlease find the Quotation below for your Enquiry\r\n';

/** Date input value (YYYY-MM-DD) or ISO → d-m-yyyy for the mail subject. */
export const formatDayMonthYear = (dateLike?: string | null): string => {
  if (!dateLike?.trim()) return '';
  const dayPart = dateLike.trim().split('T')[0]!;
  const [year, month, day] = dayPart.split('-').map((part) => Number(part));
  if (!year || !month || !day) return dateLike.trim();
  return `${day}-${month}-${year}`;
};

export const buildIssueMailSubject = (quotationNumber: string, receivedOn?: string | null): string => {
  const number = quotationNumber.trim();
  const received = formatDayMonthYear(receivedOn);
  if (number && received) return `Quotation - ${number}, ${received}`;
  if (number) return `Quotation - ${number}`;
  if (received) return `Quotation, ${received}`;
  return 'Quotation';
};

export interface IssueMailComposeInput {
  to: string;
  quotationNumber: string;
  receivedOn?: string | null;
  /** Replaces the quotation subject. The quotation close stage leaves this unset. */
  subject?: string;
  /** Replaces the quotation body. The quotation close stage leaves this unset. */
  body?: string;
}

export const buildOutlookIssueMailComposeUrl = (
  input: IssueMailComposeInput,
  baseUrl = DEFAULT_OUTLOOK_COMPOSE
): string => {
  const subject = input.subject?.trim() || buildIssueMailSubject(input.quotationNumber, input.receivedOn);
  const body = input.body ?? ISSUE_MAIL_BODY;
  // Outlook deeplink expects %20 for spaces; URLSearchParams uses + which Outlook shows literally.
  const query = [
    `to=${encodeURIComponent(input.to.trim())}`,
    `subject=${encodeURIComponent(subject)}`,
    `body=${encodeURIComponent(body)}`,
  ].join('&');
  const joiner = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${joiner}${query}`;
};

export const openOutlookIssueMailCompose = (input: IssueMailComposeInput): void => {
  window.open(buildOutlookIssueMailComposeUrl(input), '_blank', 'noopener,noreferrer');
};
